import { BookingTolerancesListItem } from "../../../integrated-client/models/";

interface ITableData {
  records: Array<BookingTolerancesListItem>;
}

export class TableData implements ITableData {
  records: Array<BookingTolerancesListItem>;

  constructor() {
    this.records = [];
  }
}
